import { createSelector } from 'reselect';
 
const selectOneConfigurations = (state: any) => state.oneConfigurations;
 
export const selectOneConfigurationsCurrentItem = createSelector([selectOneConfigurations], (oneConfigurations) => oneConfigurations.current);
 
export const selectOneConfigurationsListItems = createSelector([selectOneConfigurations], (oneConfigurations) => oneConfigurations.list);
 
 
export const selectOneConfigurationsItemById = (itemId: any) =>
    createSelector(selectOneConfigurationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectOneConfigurationsQueryItems = createSelector([selectOneConfigurations], (oneConfigurations) => oneConfigurations.query);

export const selectOneConfigurationsCreatedItem = createSelector([selectOneConfigurations], (oneConfigurations) => oneConfigurations.create);
 
export const selectOneConfigurationsUpdatedItem = createSelector([selectOneConfigurations], (oneConfigurations) => oneConfigurations.update);
 
export const selectOneConfigurationsReadItem = createSelector([selectOneConfigurations], (oneConfigurations) => oneConfigurations.read);
 
export const selectOneConfigurationsDeletedItem = createSelector([selectOneConfigurations], (oneConfigurations) => oneConfigurations.delete);
 
export const selectOneConfigurationsSearchedItems = createSelector([selectOneConfigurations], (oneConfigurations) => oneConfigurations.search);
 
export const selectOneConfigurationsItemsCount = createSelector([selectOneConfigurations], (oneConfigurations) => oneConfigurations.count);
 
export const selectOneConfigurationsItemsFilter = createSelector([selectOneConfigurations], (oneConfigurations) => oneConfigurations.filter);